/**
 * Game items configuration
 *
 * This file is auto-generated by the balance importer.
 * Do not edit manually - changes will be overwritten.
 *
 * Generated at: 2025-09-25T12:43:18.982Z
 */

import { ConfigType } from './ConfigType';

export interface ItemConfig {
  item_id: string;
  name: string;
  icon: string | null;
  type: string;
  world: number;
  tier: number;
  base_price: number;
  sell_price: number;
  floors: string | null;
  configType: ConfigType.ITEMS;
}

export const itemsData: Record<string, ItemConfig> = {
  credits: {
    item_id: 'credits',
    name: 'Credits',
    icon: 'icons/credit.png',
    type: 'currency',
    world: 1,
    tier: 0,
    base_price: 1,
    sell_price: 1,
    floors: '—',
    configType: ConfigType.ITEMS,
  },
  ore_stone: {
    item_id: 'ore_stone',
    name: 'Stone Ore',
    icon: 'icons/stone-ore.png',
    type: 'ore',
    world: 1,
    tier: 1,
    base_price: 5,
    sell_price: 5,
    floors: '1–2',
    configType: ConfigType.ITEMS,
  },
  ore_crystal: {
    item_id: 'ore_crystal',
    name: 'Crystal Ore',
    icon: 'icons/crystal-ore.png',
    type: 'ore',
    world: 1,
    tier: 2,
    base_price: 6,
    sell_price: 6,
    floors: '1–4',
    configType: ConfigType.ITEMS,
  },
  ore_mithril: {
    item_id: 'ore_mithril',
    name: 'Phase-Mithril Crystal',
    icon: null,
    type: 'ore',
    world: 1,
    tier: 3,
    base_price: 7,
    sell_price: 7,
    floors: '3–6',
    configType: ConfigType.ITEMS,
  },
  ore_adamant: {
    item_id: 'ore_adamant',
    name: 'Hardlight Adamant',
    icon: null,
    type: 'ore',
    world: 1,
    tier: 4,
    base_price: 8,
    sell_price: 8,
    floors: '5–8',
    configType: ConfigType.ITEMS,
  },
  ore_runite: {
    item_id: 'ore_runite',
    name: 'Runecircuit Ore',
    icon: null,
    type: 'ore',
    world: 1,
    tier: 5,
    base_price: 9,
    sell_price: 9,
    floors: '7–10',
    configType: ConfigType.ITEMS,
  },
  ore_citrine: {
    item_id: 'ore_citrine',
    name: 'Synth-Citrine',
    icon: null,
    type: 'ore',
    world: 1,
    tier: 6,
    base_price: 10,
    sell_price: 10,
    floors: '9–12',
    configType: ConfigType.ITEMS,
  },
  ore_amethyst: {
    item_id: 'ore_amethyst',
    name: 'Night-Amethyst',
    icon: null,
    type: 'ore',
    world: 1,
    tier: 7,
    base_price: 11,
    sell_price: 11,
    floors: '11–14',
    configType: ConfigType.ITEMS,
  },
  ore_topaz: {
    item_id: 'ore_topaz',
    name: 'Overdrive Topaz',
    icon: null,
    type: 'ore',
    world: 1,
    tier: 8,
    base_price: 12,
    sell_price: 12,
    floors: '13–16',
    configType: ConfigType.ITEMS,
  },
  ore_obsidian: {
    item_id: 'ore_obsidian',
    name: 'Deep Obsidian',
    icon: null,
    type: 'ore',
    world: 1,
    tier: 9,
    base_price: 13,
    sell_price: 13,
    floors: '15–18',
    configType: ConfigType.ITEMS,
  },
  ore_demonite: {
    item_id: 'ore_demonite',
    name: 'Demonite Ember',
    icon: null,
    type: 'ore',
    world: 1,
    tier: 10,
    base_price: 14,
    sell_price: 14,
    floors: '17–18',
    configType: ConfigType.ITEMS,
  },
  ore_vr_tin: {
    item_id: 'ore_vr_tin',
    name: 'VR-Tinspark',
    icon: null,
    type: 'ore',
    world: 1,
    tier: 11,
    base_price: 16,
    sell_price: 16,
    floors: '19–20',
    configType: ConfigType.ITEMS,
  },
  ore_vr_amethyst: {
    item_id: 'ore_vr_amethyst',
    name: 'VR-Night Amethyst',
    icon: null,
    type: 'ore',
    world: 1,
    tier: 12,
    base_price: 18,
    sell_price: 18,
    floors: '19–22',
    configType: ConfigType.ITEMS,
  },
  ore_vr_demonite: {
    item_id: 'ore_vr_demonite',
    name: 'VR-Demonite',
    icon: null,
    type: 'ore',
    world: 1,
    tier: 13,
    base_price: 20,
    sell_price: 20,
    floors: '21–24',
    configType: ConfigType.ITEMS,
  },
  ore_vr_error: {
    item_id: 'ore_vr_error',
    name: 'VR-ERROR Fragment',
    icon: null,
    type: 'ore',
    world: 1,
    tier: 14,
    base_price: 22,
    sell_price: 22,
    floors: '23–24',
    configType: ConfigType.ITEMS,
  },
  ore_lunarium: {
    item_id: 'ore_lunarium',
    name: 'Moonwire Lunarium',
    icon: null,
    type: 'ore',
    world: 1,
    tier: 15,
    base_price: 25,
    sell_price: 25,
    floors: '25–26',
    configType: ConfigType.ITEMS,
  },
  ore_earth_c137: {
    item_id: 'ore_earth_c137',
    name: 'C-137 Geode',
    icon: null,
    type: 'ore',
    world: 1,
    tier: 16,
    base_price: 28,
    sell_price: 28,
    floors: '25–28',
    configType: ConfigType.ITEMS,
  },
  ore_meteorite: {
    item_id: 'ore_meteorite',
    name: 'Meteor Shard',
    icon: null,
    type: 'ore',
    world: 1,
    tier: 17,
    base_price: 31,
    sell_price: 31,
    floors: '27–30',
    configType: ConfigType.ITEMS,
  },
  ore_singularity: {
    item_id: 'ore_singularity',
    name: 'Singularity Node',
    icon: null,
    type: 'ore',
    world: 1,
    tier: 18,
    base_price: 34,
    sell_price: 34,
    floors: '29–30',
    configType: ConfigType.ITEMS,
  },
  ore_halium: {
    item_id: 'ore_halium',
    name: 'Halium Platelet',
    icon: null,
    type: 'ore',
    world: 1,
    tier: 19,
    base_price: 38,
    sell_price: 38,
    floors: '31–32',
    configType: ConfigType.ITEMS,
  },
  ore_blasphemite: {
    item_id: 'ore_blasphemite',
    name: 'Blasphemite',
    icon: null,
    type: 'ore',
    world: 1,
    tier: 20,
    base_price: 42,
    sell_price: 42,
    floors: '31–34',
    configType: ConfigType.ITEMS,
  },
  ore_angelite: {
    item_id: 'ore_angelite',
    name: 'Angelite Prism',
    icon: null,
    type: 'ore',
    world: 1,
    tier: 21,
    base_price: 46,
    sell_price: 46,
    floors: '33–36',
    configType: ConfigType.ITEMS,
  },
  ore_elysium: {
    item_id: 'ore_elysium',
    name: 'Elysium Ingotite',
    icon: null,
    type: 'ore',
    world: 1,
    tier: 22,
    base_price: 50,
    sell_price: 50,
    floors: '35–36',
    configType: ConfigType.ITEMS,
  },
  ore_enemite: {
    item_id: 'ore_enemite',
    name: 'Enemite Spore',
    icon: null,
    type: 'ore',
    world: 1,
    tier: 23,
    base_price: 60,
    sell_price: 60,
    floors: '37–38',
    configType: ConfigType.ITEMS,
  },
  ore_beepboopium: {
    item_id: 'ore_beepboopium',
    name: 'Beep-Boopium',
    icon: null,
    type: 'ore',
    world: 1,
    tier: 24,
    base_price: 70,
    sell_price: 70,
    floors: '37–40',
    configType: ConfigType.ITEMS,
  },
  ore_radion73: {
    item_id: 'ore_radion73',
    name: 'Radion-73',
    icon: null,
    type: 'ore',
    world: 1,
    tier: 25,
    base_price: 80,
    sell_price: 80,
    floors: '39–42',
    configType: ConfigType.ITEMS,
  },
  ore_cranium: {
    item_id: 'ore_cranium',
    name: 'Cranium Core',
    icon: null,
    type: 'ore',
    world: 1,
    tier: 26,
    base_price: 90,
    sell_price: 90,
    floors: '41–42',
    configType: ConfigType.ITEMS,
  },
  bar_stone: {
    item_id: 'bar_stone',
    name: 'Stone Bar',
    icon: 'icons/stone-bar.png',
    type: 'bar',
    world: 1,
    tier: 1,
    base_price: 10,
    sell_price: 10,
    floors: null,
    configType: ConfigType.ITEMS,
  },
  bar_crystal: {
    item_id: 'bar_crystal',
    name: 'Crystal Bar',
    icon: 'icons/crystal-bar.png',
    type: 'bar',
    world: 1,
    tier: 2,
    base_price: 12,
    sell_price: 12,
    floors: null,
    configType: ConfigType.ITEMS,
  },
  bar_phase_mithril: {
    item_id: 'bar_phase_mithril',
    name: 'Phase-Mithril Bar',
    icon: null,
    type: 'bar',
    world: 1,
    tier: 3,
    base_price: 14,
    sell_price: 14,
    floors: null,
    configType: ConfigType.ITEMS,
  },
  bar_hardlight_adamant: {
    item_id: 'bar_hardlight_adamant',
    name: 'Hardlight Adamant Bar',
    icon: null,
    type: 'bar',
    world: 1,
    tier: 4,
    base_price: 16,
    sell_price: 16,
    floors: null,
    configType: ConfigType.ITEMS,
  },
  bar_runecircuit: {
    item_id: 'bar_runecircuit',
    name: 'Runecircuit Bar',
    icon: null,
    type: 'bar',
    world: 1,
    tier: 5,
    base_price: 18,
    sell_price: 18,
    floors: null,
    configType: ConfigType.ITEMS,
  },
  bar_synth_citrine: {
    item_id: 'bar_synth_citrine',
    name: 'Synth-Citrine Bar',
    icon: null,
    type: 'bar',
    world: 1,
    tier: 6,
    base_price: 20,
    sell_price: 20,
    floors: null,
    configType: ConfigType.ITEMS,
  },
  bar_night_amethyst: {
    item_id: 'bar_night_amethyst',
    name: 'Night-Amethyst Bar',
    icon: null,
    type: 'bar',
    world: 1,
    tier: 7,
    base_price: 22,
    sell_price: 22,
    floors: null,
    configType: ConfigType.ITEMS,
  },
  bar_overdrive_topaz: {
    item_id: 'bar_overdrive_topaz',
    name: 'Overdrive Topaz Bar',
    icon: null,
    type: 'bar',
    world: 1,
    tier: 8,
    base_price: 24,
    sell_price: 24,
    floors: null,
    configType: ConfigType.ITEMS,
  },
  bar_deep_obsidian: {
    item_id: 'bar_deep_obsidian',
    name: 'Deep Obsidian Bar',
    icon: null,
    type: 'bar',
    world: 1,
    tier: 9,
    base_price: 26,
    sell_price: 26,
    floors: null,
    configType: ConfigType.ITEMS,
  },
  bar_demonite_ember: {
    item_id: 'bar_demonite_ember',
    name: 'Demonite Ember Bar',
    icon: null,
    type: 'bar',
    world: 1,
    tier: 10,
    base_price: 28,
    sell_price: 28,
    floors: null,
    configType: ConfigType.ITEMS,
  },
  bar_vr_tinspark: {
    item_id: 'bar_vr_tinspark',
    name: 'VR-Tinspark Bar',
    icon: null,
    type: 'bar',
    world: 1,
    tier: 11,
    base_price: 32,
    sell_price: 32,
    floors: null,
    configType: ConfigType.ITEMS,
  },
  bar_vr_night_amethyst: {
    item_id: 'bar_vr_night_amethyst',
    name: 'VR-Night Amethyst Bar',
    icon: null,
    type: 'bar',
    world: 1,
    tier: 12,
    base_price: 36,
    sell_price: 36,
    floors: null,
    configType: ConfigType.ITEMS,
  },
  bar_vr_demonite: {
    item_id: 'bar_vr_demonite',
    name: 'VR-Demonite Bar',
    icon: null,
    type: 'bar',
    world: 1,
    tier: 13,
    base_price: 40,
    sell_price: 40,
    floors: null,
    configType: ConfigType.ITEMS,
  },
  bar_vr_error: {
    item_id: 'bar_vr_error',
    name: 'VR-ERROR Bar',
    icon: null,
    type: 'bar',
    world: 1,
    tier: 14,
    base_price: 44,
    sell_price: 44,
    floors: null,
    configType: ConfigType.ITEMS,
  },
  bar_moonwire_lunarium: {
    item_id: 'bar_moonwire_lunarium',
    name: 'Moonwire Lunarium Bar',
    icon: null,
    type: 'bar',
    world: 1,
    tier: 15,
    base_price: 50,
    sell_price: 50,
    floors: null,
    configType: ConfigType.ITEMS,
  },
  bar_c137_geode: {
    item_id: 'bar_c137_geode',
    name: 'C-137 Geode Bar',
    icon: null,
    type: 'bar',
    world: 1,
    tier: 16,
    base_price: 56,
    sell_price: 56,
    floors: null,
    configType: ConfigType.ITEMS,
  },
  bar_meteor_shard: {
    item_id: 'bar_meteor_shard',
    name: 'Meteor Shard Bar',
    icon: null,
    type: 'bar',
    world: 1,
    tier: 17,
    base_price: 62,
    sell_price: 62,
    floors: null,
    configType: ConfigType.ITEMS,
  },
  bar_singularity_node: {
    item_id: 'bar_singularity_node',
    name: 'Singularity Node Bar',
    icon: null,
    type: 'bar',
    world: 1,
    tier: 18,
    base_price: 68,
    sell_price: 68,
    floors: null,
    configType: ConfigType.ITEMS,
  },
  bar_halium_platelet: {
    item_id: 'bar_halium_platelet',
    name: 'Halium Platelet Bar',
    icon: null,
    type: 'bar',
    world: 1,
    tier: 19,
    base_price: 76,
    sell_price: 76,
    floors: null,
    configType: ConfigType.ITEMS,
  },
  bar_blasphemite: {
    item_id: 'bar_blasphemite',
    name: 'Blasphemite Bar',
    icon: null,
    type: 'bar',
    world: 1,
    tier: 20,
    base_price: 84,
    sell_price: 84,
    floors: null,
    configType: ConfigType.ITEMS,
  },
  bar_angelite_prism: {
    item_id: 'bar_angelite_prism',
    name: 'Angelite Prism Bar',
    icon: null,
    type: 'bar',
    world: 1,
    tier: 21,
    base_price: 92,
    sell_price: 92,
    floors: null,
    configType: ConfigType.ITEMS,
  },
  bar_elysium_ingotite: {
    item_id: 'bar_elysium_ingotite',
    name: 'Elysium Ingotite Bar',
    icon: null,
    type: 'bar',
    world: 1,
    tier: 22,
    base_price: 100,
    sell_price: 100,
    floors: null,
    configType: ConfigType.ITEMS,
  },
  bar_enemite_spore: {
    item_id: 'bar_enemite_spore',
    name: 'Enemite Spore Bar',
    icon: null,
    type: 'bar',
    world: 1,
    tier: 23,
    base_price: 120,
    sell_price: 120,
    floors: null,
    configType: ConfigType.ITEMS,
  },
  bar_beepboopium: {
    item_id: 'bar_beepboopium',
    name: 'Beep-Boopium Bar',
    icon: null,
    type: 'bar',
    world: 1,
    tier: 24,
    base_price: 140,
    sell_price: 140,
    floors: null,
    configType: ConfigType.ITEMS,
  },
  bar_radion73: {
    item_id: 'bar_radion73',
    name: 'Radion-73 Bar',
    icon: null,
    type: 'bar',
    world: 1,
    tier: 25,
    base_price: 160,
    sell_price: 160,
    floors: null,
    configType: ConfigType.ITEMS,
  },
  bar_cranium_core: {
    item_id: 'bar_cranium_core',
    name: 'Cranium Core Bar',
    icon: null,
    type: 'bar',
    world: 1,
    tier: 26,
    base_price: 180,
    sell_price: 180,
    floors: null,
    configType: ConfigType.ITEMS,
  },
};

/**
 * Get ItemConfig by item_id
 */
export function getItems(id: string): ItemConfig | undefined {
  return itemsData[id];
}

/**
 * Get all ItemConfig entries
 */
export function getAllItems(): ItemConfig[] {
  return Object.values(itemsData);
}

/**
 * Check if ItemConfig exists
 */
export function hasItems(id: string): boolean {
  return id in itemsData;
}
